import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import Prestazioni from '../views/PrestazioneList.vue';
import UtenteList from '../views/UtenteList.vue';
import UtenteDetail from '../views/UtenteDetail.vue';
import PrestazioneDetail from '../views/PrestazioneDetail.vue';
import Login from '../views/Login.vue';
import store from '../store';
import mainMenu from '@/components/navigation/MainMenu.vue';
import anagraficheMenu from '@/components/navigation/AnagraficheMenu.vue';
import sicurezzaMenu from '@/components/navigation/SicurezzaMenu.vue';
import AttributoList from '../views/AttributoList.vue';
import AttributoDetail from '../views/AttributoDetail.vue';
import AvvocatoList from '../views/AvvocatoList.vue';
import AvvocatoDetail from '../views/AvvocatoDetail.vue';
import CompagniaAssicurativaList from '../views/CompagniaAssicurativaList.vue';
import CompagniaAssicurativaDetail from '../views/CompagniaAssicurativaDetail.vue';
import EnteSanitarioList from '../views/EnteSanitarioList.vue';
import EnteSanitarioDetail from '../views/EnteSanitarioDetail.vue';
import OperatoreSanitarioList from '../views/OperatoreSanitarioList.vue';
import OperatoreSanitarioDetail from '../views/OperatoreSanitarioDetail.vue';
import PazienteList from '../views/PazienteList.vue';
import PazienteDetail from '../views/PazienteDetail.vue';
import RichiedenteList from '../views/RichiedenteList.vue';
import RichiedenteDetail from '../views/RichiedenteDetail.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Dashboard',
        components: {
            default: Dashboard,
            navigation: mainMenu

        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/prestazioni',
        name: 'Prestazioni',
        components: {
            default: Prestazioni,
            navigation: mainMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/prestazioni/stato/:statusId',
        name: 'PrestazioniStato',
        components: {
            default: Prestazioni,
            navigation: mainMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/prestazioni/nuovo',
        name: 'PrestazioneNew',
        components: {
            default: PrestazioneDetail,
            navigation: mainMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/prestazioni/:id',
        name: 'PrestazioneDetail',
        components: {
            default: PrestazioneDetail,
            navigation: mainMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/attributi',
        name: 'AttributoList',
        components: {
            default: AttributoList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/attributi/nuovo',
        name: 'AttributoNew',
        components: {
            default: AttributoDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/attributi/:id',
        name: 'AttributoDetail',
        components: {
            default: AttributoDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/avvocati',
        name: 'AvvocatoList',
        components: {
            default: AvvocatoList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/avvocati/nuovo',
        name: 'AvvocatoNew',
        components: {
            default: AvvocatoDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/avvocati/:id',
        name: 'AvvocatoDetail',
        components: {
            default: AvvocatoDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/compagnie-assicurative',
        name: 'CompagniaAssicurativaList',
        components: {
            default: CompagniaAssicurativaList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/compagnie-assicurative/nuovo',
        name: 'CompagniaAssicurativaNew',
        components: {
            default: CompagniaAssicurativaDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/compagnie-assicurative/:id',
        name: 'CompagniaAssicurativaDetail',
        components: {
            default: CompagniaAssicurativaDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },

    {
        path: '/enti-sanitari',
        name: 'EnteSanitarioList',
        components: {
            default: EnteSanitarioList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/enti-sanitari/nuovo',
        name: 'EnteSanitarioNew',
        components: {
            default: EnteSanitarioDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/enti-sanitari/:id',
        name: 'EnteSanitarioDetail',
        components: {
            default: EnteSanitarioDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/operatori-sanitari',
        name: 'OperatoreSanitarioList',
        components: {
            default: OperatoreSanitarioList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/operatori-sanitari/nuovo',
        name: 'OperatoreSanitarioNew',
        components: {
            default: OperatoreSanitarioDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/operatori-sanitari/:id',
        name: 'OperatoreSanitarioDetail',
        components: {
            default: OperatoreSanitarioDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/pazienti',
        name: 'PazienteList',
        components: {
            default: PazienteList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/pazienti/nuovo',
        name: 'PazienteNew',
        components: {
            default: PazienteDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/pazienti/:id',
        name: 'PazienteDetail',
        components: {
            default: PazienteDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/richiedenti',
        name: 'RichiedenteList',
        components: {
            default: RichiedenteList,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/richiedenti/nuovo',
        name: 'RichiedenteNew',
        components: {
            default: RichiedenteDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/richiedenti/:id',
        name: 'RichiedenteDetail',
        components: {
            default: RichiedenteDetail,
            navigation: anagraficheMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/utenti',
        name: 'UtenteList',
        components: {
            default: UtenteList,
            navigation: sicurezzaMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/utenti/nuovo',
        name: 'UtenteNew',
        components: {
            default: UtenteDetail,
            navigation: sicurezzaMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/utenti/:id',
        name: 'UtenteDetail',
        components: {
            default: UtenteDetail,
            navigation: sicurezzaMenu
        },
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            requiresAuth: false
        }
    },

];

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    const loggedUser = store.state.loggedUser;
    // verifico autenticazione
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !loggedUser) {
        // sparo alla pagina di login
        next('/login');

    } else {
        // avanzo
        next();
    }

});

export default router;
